
import { DashboardMenu } from "../../data/menu"
import BreadCrump from "../tools/breadcrump"
import { getCookies } from "cookies-next";
import { useEffect, useState } from "react";
import axios from "axios";
import Swal from 'sweetalert2';
import changeUrl from "../../hoc/changeur";
import { config } from "../../data/config";

import { useTranslation } from 'react-i18next';
import { Button } from "rsuite";
import { QRCodeCanvas } from "qrcode.react";
import HeaderOfPage from "../tools/headerOfPage";

export default function ListProductsGroup() {
    const { t } = useTranslation();
    const [parent, setParent] = useState<any>("");

    const breadcrump = [
        {
            name: 'Dashboard',
            url: '/dashboard'
        },
        {
            name: 'Products',
            url: '/dashboard/Products'
        },
        {
            name: 'Products Group List',
            url: null
        },
    ]
    const reloadgame = () => {
        let x = key + 1;
        setKey(x);
    }
    const setParents = (id: any) => {

        setParent(id);
        let x = key2 + 1;
        setKey2(x);

    }
    const [key, setKey] = useState(1);
    const [key2, setKey2] = useState(1);

    return (
        <>
            <div className="text-right  bg-white  p-3 m-4    mb-5 " >
                <BreadCrump data={breadcrump}></BreadCrump>
                <HeaderOfPage name="Products Group List"></HeaderOfPage>


                <div className="grid grid-cols-1 sm:grid-cols-4 gap-4">
                    <div className="col-span-1  " dir="rtl">
                        <NewGroupCategory parent={parent} key={key2} reloaditem={reloadgame}></NewGroupCategory>

                    </div>
                    <div className="col-span-3 ">
                        <ListofBlog setParents={setParents} parent={parent} key={key}></ListofBlog>
                    </div>
                </div>
            </div>

        </>
    )
}
function ListofBlog({ parent, setParents }: any) {
    const { t } = useTranslation();

    let cookie = getCookies();
    const [list, setList] = useState<any>(null);

    const [error, setError] = useState<any>(null);
    const [key, setKey] = useState<any>(1);

    const getalldata = async (p: String) => {
        setError(null);

        try {
            let res = await axios({
                method: 'get',
                url: config.url + '/v1/dashboard/pgroup?parent=' + p,
                headers: {
                    Authorization: 'Bearer ' + cookie['token'],
                }
            });


            setList(res.data.message);
        } catch (error: any) {

            setError(error.response.data.message.errors);
        }
    }
    const orderttop = async (id: any) => {
        try {
            let res = await axios({
                method: 'put',
                url: config.url + '/v1/dashboard/pgroup/orderup/' + id,
                headers: {
                    Authorization: 'Bearer ' + cookie['token'],
                }
            });

            getalldata(parent);


        } catch (error: any) {

            setError(error.response.data.message.errors);
        }
    }
    const orderdown = async (id: any) => {
        try {
            let res = await axios({
                method: 'put',
                url: config.url + '/v1/dashboard/pgroup/orderdown/' + id,
                headers: {
                    Authorization: 'Bearer ' + cookie['token'],
                }
            });

            getalldata(parent);

        } catch (error: any) {

            setError(error.response.data.message.errors);
        }
    }
    const getLoadNew = async (id: any) => {
        try {
            setParents(id);
        } finally {
            getalldata(id);

        }
    }
    const deleted = async (id: any) => {

        Swal.fire({
            title: t("Are you sure?"),
            text: t("Delete this Group!"),
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: t("Yes, delete it!")
        }).then(async (result) => {
            if (result.isConfirmed) {
                try {
                    let res = await axios({
                        method: 'delete',
                        url: config.url + '/v1/dashboard/pgroup/' + id,
                        headers: {
                            Authorization: 'Bearer ' + cookie['token'],
                        }
                    })

                    getalldata(parent);
                } catch (error) {
                    console.log(error);
                }
            }
        });

    }
    useEffect(() => {
        getalldata(parent);
    }, []);
    return (
        <div>
            <div className="grid grid-cols-2 pb-4">

                <div className="  gap-3 flex   w-full">
                    <button type="button" onClick={(e) => { getalldata("") }} className="float-end py-3 px-4 inline-flex items-center gap-x-2 text-sm font-medium rounded-lg border border-transparent bg-gray-100 text-gray-800 hover:bg-gray-200 focus:outline-none focus:bg-gray-200 disabled:opacity-50 disabled:pointer-events-none ">
                        {t('Reload')}
                    </button>
                    <button type="button" onClick={(e) => { setParents("") }} className="float-end bg-yellow-100 py-3 px-4 inline-flex items-center gap-x-2 text-sm font-medium rounded-lg border border-transparent  text-gray-800 hover:bg-gray-200 focus:outline-none focus:bg-gray-200 disabled:opacity-50 disabled:pointer-events-none ">
                        {t('بالا')}
                    </button>
                </div>

            </div>
            <hr />

            <div className="flex flex-col">
                <div className="-m-1.5 overflow-x-auto">
                    <div className="p-1.5 min-w-full inline-block align-middle">
                        <div className="overflow-hidden">
                            <table className="min-w-full divide-y divide-gray-200 ">
                                <thead>
                                    <tr>
                                        <th scope="col" className="px-6 py-3  text-xs font-medium text-gray-500 uppercase  text-right">{t('Name')}  </th>
                                        <th scope="col" className="px-6 py-3  text-xs font-medium text-gray-500 uppercase text-right  ">{t('Action')} </th>
                                        <th scope="col" className="px-6 py-3  text-xs font-medium text-gray-500 uppercase text-right  ">{t('بارکد')} </th>
                                        <th scope="col" className="px-6 py-3  text-xs font-medium text-gray-500 uppercase text-right  ">{t('ترتیب')} </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {list != null && list.map((item: any) => {
                                        return (
                                            <tr className="odd:bg-white even:bg-gray-100 hover:bg-gray-100  text-right">
                                                <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-800 ">{item.name}
                                                    <p><small>{item.url}</small></p>
                                                </td>

                                                <td className="px-6 py-4 whitespace-nowrap text-center text-sm font-medium flex gap-3 ">
                                                    <a
                                                        onClick={(e) => {
                                                            getLoadNew(item.id)
                                                        }}
                                                        type="button"
                                                        className="inline-flex items-center gap-x-2 text-sm font-semibold rounded-lg border border-transparent text-blue-600 hover:text-blue-800 focus:outline-none focus:text-blue-800 disabled:opacity-50 disabled:pointer-events-none "
                                                    >{t('Subgroup')}</a>
                                                    <a
                                                        href={`/dashboard/Products/ProductsGroup/${item.id}`}
                                                        type="button"
                                                        className="inline-flex items-center gap-x-2 text-sm font-semibold rounded-lg border border-transparent text-blue-600 hover:text-blue-800 focus:outline-none focus:text-blue-800 disabled:opacity-50 disabled:pointer-events-none "
                                                    >{t('Edit')}</a>

                                                    <button
                                                        onClick={(e) => { deleted(item.id) }}
                                                        type="button"
                                                        className="inline-flex items-center gap-x-2 text-sm font-semibold rounded-lg border border-transparent text-blue-600 hover:text-blue-800 focus:outline-none focus:text-blue-800 disabled:opacity-50 disabled:pointer-events-none "
                                                    >{t('Delete')} </button>
                                                </td>
                                                <td className="p-2">
                                                    <QRCodeCanvas value={`https://nanosealco.com/group/${item.url}`} />

                                                </td>
                                                <td>
                                                    <div className="flex flex-row justify-around items-center">
                                                        <div>
                                                            <Button onClick={(e) => { orderttop(item.id) }}>
                                                                <img width={20} height={20} src="/icons/arrowup.svg"></img>
                                                            </Button>

                                                        </div>
                                                        <div>
                                                            <Button onClick={(e) => { orderdown(item.id) }}>
                                                                <img width={20} height={20} src="/icons/arrowndown.svg"></img>
                                                            </Button>
                                                        </div>
                                                    </div>
                                                </td>

                                            </tr>
                                        )
                                    })}



                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}
function NewGroupCategory({ parent, reloaditem }: any) {
    const { t } = useTranslation();

    let cookie = getCookies();
    const [data, setData] = useState<any>({
        name: '',
        url: '',
        keywords: '',
        description: '',
        parent: parent

    });
    const [error, setError] = useState(null);
    const [key, setKey] = useState(1);
    const [url, setUrl] = useState<any>(null);

    const setName = (name: any) => {


        var x = changeUrl(name);
        setData({ ...data, url: x });
        setData({ ...data, name: name });



    }
    const save = async () => {
        console.log(data);
        setError(null);
        try {
            let res = await axios({
                method: 'post',
                url: config.url + '/v1/dashboard/pgroup',
                data: data,
                headers: {
                    Authorization: 'Bearer ' + cookie['token'],
                }
            });

            let mydata = res.data;
            reloaditem();
            let x = key + 1;
            setKey(x);
            return mydata;
        } catch (error: any) {

            //  error.response.data.code != null && Swal.fire(` "${data.url}" slug is available.`);
            // setError(error.response.data.message.errors);
        }
    }

    const inputstyle = "py-3 px-5 block w-full border-gray-499 rounded text-sm focus:border-blue-500 focus:ring-blue-500 disabled:opacity-50 disabled:pointer-events-none";
    return (
        <div className=" bg-black rounded-[10px] p-5">


            <form key={key}>
                <div className="max-w-sm space-y-3">
                    <label className="text-white"> {t('Name')} </label>
                    <input
                        type="text"
                        className={`${inputstyle}     ${error != null && error['name'] != undefined && `bg-red-100`} `}
                        placeholder="Name"
                        onChange={(e) => { setName(e.target.value);; }}
                    />
                    {error != null && error['url'] != undefined && <small>{error['name']['message']}</small>}
                </div>
                <div className="max-w-sm space-y-3 mt-4">
                    <label className="text-white"> Slug </label>
                    <input
                        type="text"
                        className={`${inputstyle}       ${error != null && error['url'] != undefined && `bg-red-100`}  `}
                        placeholder="Slug"
                        onChange={(e) => setData({ ...data, url: e.target.value })}
                    />
                    {error != null && error['url'] != undefined && <small>{error['url']['message']}</small>}
                </div>
                <div className="max-w-sm space-y-3 mt-4">
                    <label className="text-white">{t('Keywords')}   </label>
                    <textarea

                        className={inputstyle}
                        onChange={(e) => setData({ ...data, keywords: e.target.value })}
                        placeholder="..." />
                </div>
                <div className="max-w-sm space-y-3 mt-4">
                    <label className="text-white">{t('Description')}   </label>
                    <textarea

                        className={inputstyle}
                        onChange={(e) => setData({ ...data, description: e.target.value })}
                        placeholder="..." />
                </div>
                <div className="max-w-sm space-y-3 mt-4">
                    <button type="button"
                        onClick={(e) => { save() }}
                        className="py-3 px-4 inline-flex items-center gap-x-2 text-sm font-medium rounded-lg border border-transparent bg-gray-100 text-gray-800 hover:bg-gray-200 focus:outline-none focus:bg-gray-200 disabled:opacity-50 disabled:pointer-events-none dark:bg-white/10 dark:text-white dark:hover:bg-white/20 dark:hover:text-white dark:focus:bg-white/20 dark:focus:text-white"
                    >
                        {t('Add Category')}
                    </button>

                </div>
            </form>
        </div>
    )
}